// DS: DEV5
import React from 'react';
import c from 'classnames';
import SimplePopperPopover from '@wix/da-ds/pkg/popper/presets/SimplePopperPopover';
import s from './NewIndicatorDot.scss';
var offsetModifier = [2, 8];
var NewIndicatorDot = function (_a) {
    var className = _a.className, contentClassName = _a.contentClassName, tooltipMessage = _a.tooltipMessage, tooltipForceTheme = _a.tooltipForceTheme;
    return (React.createElement(SimplePopperPopover, { isVisible: !!tooltipMessage, popoverContent: tooltipMessage, forceTheme: tooltipForceTheme, showArrow: true, placement: "right", offsetModifier: offsetModifier, contentClassName: c(s['tooltip-content'], contentClassName), className: className },
        React.createElement("div", { className: s['dot'] })));
};
NewIndicatorDot.displayName = 'NewIndicatorDot';
export default NewIndicatorDot;
//# sourceMappingURL=NewIndicatorDot.js.map